<template>
  <validation-observer ref="refFormObserver">
    <b-form>
      <b-row class="mx-0">
        <b-col cols="6">
          <!-- Instalacion -->
          <validation-provider #default="validationContext" name="unit">
            <b-form-group
              data-cy="facility"
              class="text-capitalize"
              :label="$tc('unit.title', 2)"
              label-for="id_unit"
              :state="getValidationState(validationContext)"
            >
              <select-paginate
                v-model="itemData.units"
                :items="unitOptions"
                input-id="id_unit"
                :multiple="true"
                @change="updateDeviceTags($event)"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <!-- Omniview reseller -->
          <validation-provider
            #default="validationContext"
            :name="$t('generic_devices.reseller')"
            rules="required"
          >
            <b-form-group
              :label="$t('generic_devices.reseller')"
              label-for="reseller"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.id_omniview_reseller"
                :options="resellerOptions"
                :reduce="(val) => val.value"
                :clearable="false"
                input-id="reseller"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row class="mx-0">
        <b-col cols="6">
          <!-- Centro -->
          <validation-provider #default="validationContext" name="center">
            <b-form-group
              data-cy="center"
              class="text-capitalize"
              :label="$tc('centers.title')"
              label-for="id_centro"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.id_center"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="centerOptions"
                :reduce="(val) => val.value"
                input-id="id_center"
                @input="changeCenter"
                :clearable="false"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <!-- Sector -->
          <validation-provider #default="validationContext" name="sector">
            <b-form-group
              data-cy="sector"
              class="text-capitalize"
              :label="$tc('sectors.title')"
              label-for="id_sector"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.id_sector"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="sectorOptions"
                :reduce="(val) => val.value"
                input-id="id_sector"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";
import SelectPaginate from "@/views/components/SelectPaginate.vue";
import { ref, watch } from "@vue/composition-api";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import store from "@/store";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    SelectPaginate,
  },
  props: {
    unitOptions: {
      type: Array,
      required: true,
    },
    centerOptions: {
      type: Array,
      required: true,
    },
    sectorOptions: {
      type: Array,
      required: true,
    },
    resellerOptions: {
      type: Array,
      required: true,
    },
    propItemData: {
      type: Object,
      required: false,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18nUtils();
    const { refFormObserver, getValidationState } = formValidation();
    const itemData = ref(JSON.parse(JSON.stringify(props.propItemData)));

    const validateStep = () => {
      return refFormObserver.value.validate();
    };

    const setupWatcher = (itemData, key) => {
      watch(
        () => itemData.value[key],
        (newValue, oldValue) => {
          if (newValue !== oldValue) {
            emit("update:itemData", { [key]: newValue });
          }
        }
      );
    };

    const updateDeviceTags = (unitsParam) => {
      if (!unitsParam) return;
      let idsTenants = unitsParam.map((unit) => unit.id_tenant);
      store.dispatch("tenant/getDeviceTagsByTenantIds", { id_tenants: idsTenants });
    };

    const changeCenter = () => {
      store
        .dispatch("sector/getAll", {
          id_center: [itemData.value.id_center],
        })
        .then(() => {
          const sector = props.sectorOptions.filter(
            (item) => item.value == itemData.value.id_sector
          );

          if (sector.length == 0) itemData.value.id_sector = "";
        });
    };

    watch(
      () => props.propItemData,
      (newValue) => {
        itemData.value = { ...newValue };
      },
      { deep: true }
    );

    setupWatcher(itemData, "units");
    setupWatcher(itemData, "id_center");
    setupWatcher(itemData, "id_sector");
    setupWatcher(itemData, "id_omniview_reseller");

    return {
      t,
      refFormObserver,
      getValidationState,
      validateStep,
      updateDeviceTags,
      changeCenter,
      itemData,
    };
  },
};
</script>
